import { useNoteNames } from "../../Project/ProjectStore"
import { Music } from "../../Util/Music/Music"
import './LinearKey.scss'

export function LinearScale(props:{noteNames:string[]}){
    return(
                <div className={'linear-key'}>
                    <table cellSpacing="0">
                        <tbody>
                            <tr className={'notes'}>
                            {props.noteNames.map((noteName:string, index:number)=>{
                                return(<td key={index} className={'linear-note-name'}>{noteName}</td>)
                            })}
                            </tr>
                        </tbody>
                    </table>
                </div>
    )
}